<template>
  <v-dialog v-if="dialogOpen" v-model="dialogOpen" persistent max-width="840px">
    <v-card style="height: 90vh">
      <v-toolbar flat :color="site.color" dark height="48px">
        <v-toolbar-title>{{ $t("textFilePreview") }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="onSaveFile()" :disabled="!fileUrl">
          <v-icon>mdi-download</v-icon>
        </v-btn>
        <v-btn icon @click="handleClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text
        class="pa-2"
        style="height: calc(90vh - 48px); overflow-y: auto"
      >
        <v-row
          no-gutters
          :style="{
            height: showDescription ? 'calc(100% - 160px)' : '100%',
          }"
        >
          <v-col cols="12" style="height: 100%">
            <v-img
              v-if="isImage(fileUrl)"
              :src="fileUrl"
              contain
              style="width: 100%; height: 100%"
            ></v-img>
            <vue-plyr v-else-if="isVideo(fileUrl)" ref="plyr">
              <video
                controls
                crossorigin
                playsinline
                data-plyr-config='{ "ratio": "4:3" }'
              >
                <source :src="fileUrl" size="720" type="video/mp4" />
              </video>
            </vue-plyr>
            <embed
              v-else-if="isPDF(fileUrl)"
              :src="fileUrl"
              type="application/pdf"
              width="100%"
              height="100%"
            />
            <vue-office-excel
              v-else-if="isSpreadsheet(fileUrl)"
              :src="fileUrl"
              @error="onError"
              style="width: 100%; height: 100%"
            />
            <div
              v-else
              class="d-flex justify-center align-center flex-column"
              style="height: 100%; gap: 8px"
            >
              <v-icon size="48">mdi-file-cancel-outline</v-icon>
              <div class="text-h6">ไม่รองรับประเภทไฟล์นี้</div>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="showDescription" no-gutters>
          <v-col cols="12" class="pt-4">
            <v-textarea
              readonly
              filled
              label="Description"
              auto-grow
              hide-details=""
              :value="description"
              style="width: 100%"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
  
<script>
import VueOfficeExcel from "@vue-office/excel";
import "@vue-office/excel/lib/index.css";
import { mapState } from "vuex";

export default {
  inject: ["isAppLoading"],
  emits: ["onClose"],
  props: {
    dialogOpen: { default: false },
    fileUrl: { default: "" },
    fileName: { default: "" },
    showDescription: { default: false },
    description: { default: "" },
  },
  components: { VueOfficeExcel },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit("onClose");
    },
    isImage(link) {
      return /\.(gif|jpe?g|jfif|tiff?|png|webp|bmp|avif|svg)$/i.test(link);
    },
    isVideo(link) {
      return /\.(mp4|webm|ogg|avi|mov)$/i.test(link);
    },
    isPDF(link) {
      return /\.pdf$/i.test(link);
    },
    isSpreadsheet(link) {
      return /\.(xls|xlsx|csv)$/i.test(link);
    },

    async onInit() {
      this.isAppLoading(true);
      this.isAppLoading(false);
    },
    onError(error) {
      console.log(error);
    },
    async onSaveFile() {
      if (!this.fileUrl) return;
      let filename = this.fileName || this.fileUrl;

      let response = await fetch(this.fileUrl, {
        cache: "no-cache",
      });
      let blob = await response.blob();
      let url = await URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = url;
      a.crossOrigin = "Anonymous";
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
  watch: {
    dialogOpen: {
      handler() {
        if (this.dialogOpen) {
          document.documentElement.style.overflow = "hidden";
          this.onInit();
        } else {
          document.documentElement.style.overflow = "auto";
          if (this.$refs.plyr) {
            this.$refs.plyr.player.stop();
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
  
<style scoped>
</style>